import type { HelpFile } from '../../types/help'
import { LlmPromptsTestIds } from '../../../testids/LlmPromptsTestIds'

export const llmPromptsHelp: HelpFile = {
  docPage: '/docs/admin/llm-prompts',
  texts: {
    [LlmPromptsTestIds.llmPromptsList]: 'Prompt templates that drive LLM-assisted features — SQL generation, table selection, migration suggestions, and the script assistant.',
    [LlmPromptsTestIds.llmPromptsTable]: null,
    [LlmPromptsTestIds.colKey]: 'Machine identifier referenced by the consuming feature (e.g., "sql-query").',
    [LlmPromptsTestIds.colDisplayName]: null,
    [LlmPromptsTestIds.colDescription]: null,
    [LlmPromptsTestIds.colLastUpdated]: null,
  },
}
